import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import "./SignUpFrom2.css";
import "./status.css";
import { baseURLs } from "../constants";
import { FaSearch,FaTruck } from "react-icons/fa";

const SignUpForm = () => {
  const navigate = useNavigate();
  const [idCard, setIdCard] = useState("");
  const [uploadId, setUploadId] = useState("");
  const [memberInfo, setMemberInfo] = useState(null);
  const [status, setStatus] = useState(null);

  const handleIdCardChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); 
    if (value.length > 13) value = value.slice(0, 13);

    if (value.length >= 1) {
      value = value.replace(/^(\d{1})(\d{0,4})?(\d{0,5})?(\d{0,2})?(\d{0,1})?$/,
        (_, p1, p2 = "", p3 = "", p4 = "", p5 = "") =>
          `${p1}${p2 ? "-" + p2 : ""}${p3 ? "-" + p3 : ""}${p4 ? "-" + p4 : ""}${p5 ? "-" + p5 : ""}`
      );
    }

    setIdCard(value);
  };

  const checkRegistrationStatus = async () => {
    if (!idCard || !uploadId) {
      Swal.fire({
        icon: "warning",
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        text: "โปรดใส่รหัสบัตรประชาชนและรหัสยืนยันตัวตน",
      });
      return;
    }
  

    const metadata = {
      personalId: idCard.replace(/-/g, ""),
      authenId: uploadId,
    };
    const formDataObj = new FormData();
    formDataObj.append("Metadata", JSON.stringify(metadata));

    try {
      const response = await axios.post(
        `${baseURLs.api}/Home/CheckStatusReg`,
        formDataObj,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Accept: "application/json",
          },
        }
      );
      const data = response.data;
     

      if (data === false) {

        Swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูลสมาชิก",
          text: "API ตอบกลับ: ไม่พบข้อมูลสมาชิกหรือข้อมูลไม่ถูกต้อง",
        });
      } else if (data && data.memberId) {

        setMemberInfo({
          Firstname_reg: data.Firstname_reg,
          LastName_reg: data.LastName_reg,
          memberId: data.memberId,
        });



        Swal.fire({
          icon: "success",
          title: "พบข้อมูลสมาชิก",
          
        });
      } else {

        Swal.fire({
          icon: "error",
          title: "ไม่พบข้อมูล",
          text: "",
        });
        setMemberInfo(null)
      }
    } catch (error) {
      
      Swal.fire({
        icon: "error",
        title: "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาลองใหม่อีกครั้ง",
        text: error.response?.data?.message || "ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาลองใหม่อีกครั้ง",
      });
    }

  };
 
  return (
    <div
      style={{
        backgroundImage: "url('/RegisterAssoc/tower.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
        padding: "50px 40px 40px",
      }}
    >
      <div className="row justify-content-center align-items-center min-vh-100">
        <div className="col-12 col-md-8 col-lg-6">
          <div className="card shadow p-4">
            <h2 className="text-center mb-4">ตรวจสอบการสมัครสมาชิก</h2>

            {/* 🔹 กรอกรหัสบัตรประชาชน */}
            <div className="form-group mb-3">
              <label htmlFor="id-card" className="form-label">รหัสบัตรประชาชน</label>
              <input
                type="text"
                className="form-control"
                id="id-card"
                placeholder="กรอกเลขบัตรประชาชน 13 หลัก"
                value={idCard}
                onChange={handleIdCardChange}
                maxLength={17}
                required
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="verification-code" className="form-label">
                รหัสยืนยันตัวตน
              </label>
              <input
                type="text"
                className="form-control"
                id="verification-code"
                placeholder="กรอกรหัสยืนยันตัวตนจากอีเมล์"
                value={uploadId}
                onChange={(e) => {

                  const onlyNumbers = e.target.value.replace(/\D/g, "").slice(0, 10);
                  setUploadId(`Aln-${onlyNumbers}`);
                }}
                inputMode="numeric"
                required
              />
            </div>
            {/* 🔹 ปุ่มตรวจสอบสถานะ */}
            <div className="form-group d-flex justify-content-center align-items-center mt-4">
              <button onClick={checkRegistrationStatus} className="btn btn-primary w-50">
                ตรวจสอบสถานะ
              </button>
            </div>

            {/* 🔹 แสดงผลข้อมูลสมาชิก (ถ้ามี) */}
            {memberInfo && (
              <div className="mt-4 alert  text-center">
                <p>ชื่อ: <strong>{memberInfo.Firstname_reg}</strong></p>
                <p>นามสกุล: <strong>{memberInfo.LastName_reg}</strong></p>
                <p>
                  เลขสมาชิก:{""}
                  <strong>{memberInfo.memberId ? memberInfo.memberId : "อยู่ระหว่างเจ้าหน้าที่ตรวจสอบ"}</strong>
                </p>
                <div className="status-steps" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px' }}>
                  <div className="status-steps" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '40px' }}>
                    <div className="step success" style={{ textAlign: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center', color: 'green' }}>
                      <FaSearch className="icon" style={{ fontSize: '40px' }} />
                      <div>กำลังตรวจสอบข้อมูล</div>
                    </div>

                    <div
                      // className={`step ${memberInfo?.memberId ? "success" : "error"}`}
                      style={{
                        textAlign: "center",
                        flexDirection: "column",
                        display: "flex",
                        alignItems: "center",
                        color: memberInfo?.memberId == "อยู่ระหว่างเจ้าหน้าที่ตรวจสอบ" ? "gray" : "green",
                      }}

                    >
                      <FaTruck
                        className="icon"
                        style={{
                          fontSize: "40px",
                          color: memberInfo?.memberId == "อยู่ระหว่างเจ้าหน้าที่ตรวจสอบ" ? "gray" : "green",
                        }}
                      />
                      <div>อยู่ระหว่างกำลังจัดส่ง</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignUpForm;
